<ng-container *ngIf="!item.nestedItems || item.nestedItems?.length === 0">
  <ng-container *ngIf="!item.url">
    <glxy-nav-item
      [ngClass]="{ active: item.menuId === activeMenuId }"
      [id]="item.menuId"
      (click)="onClick($event)"
      [icon]="item.icon"
      [isSvg]="item.svgIcon"
      [attr.data-action]="'PartnerCenter:Nav:clicked-' + item.menuId"
    >
      {{ item.label | translate }}
      <glxy-nav-item-accessory *ngTemplateOutlet="navIcon"></glxy-nav-item-accessory>
    </glxy-nav-item>
  </ng-container>

  <ng-container *ngIf="item.subsectionHeader">
    <glxy-nav-subheader>
      {{ item.subsectionHeader | translate }}
    </glxy-nav-subheader>
  </ng-container>

  <ng-container *ngIf="hasDirectLink">
    <glxy-nav-item
      [ngClass]="{ active: item.menuId === activeMenuId }"
      [id]="item.menuId"
      (click)="navTabClicked($event, item)"
      [route]="item.ngRoute ? item.url : ''"
      [href]="!item.ngRoute ? item.url : ''"
      [target]="item.popOut ? '_blank' : '_self'"
      [icon]="item.icon"
      [isSvg]="item.svgIcon"
      [attr.data-action]="'PartnerCenter:Nav:clicked-' + item.menuId"
    >
      {{ item.label | translate }}
      <glxy-nav-item-accessory *ngTemplateOutlet="navIcon"></glxy-nav-item-accessory>
    </glxy-nav-item>
  </ng-container>

  <ng-container *ngIf="linkIsHandledInComponent">
    <glxy-nav-item
      [ngClass]="{
        active: item.menuId === activeMenuId
      }"
      [activeExactRoute]="true"
      [id]="item.menuId"
      (click)="navTabClicked($event, item)"
      [route]="item.ngRoute ? item.url : ''"
      [href]="!item.ngRoute ? item.url : ''"
      [target]="item.popOut ? '_blank' : '_self'"
      [icon]="item.icon"
      [isSvg]="item.svgIcon"
      [attr.data-action]="'PartnerCenter:Nav:clicked-' + item.menuId"
    >
      {{ item.label | translate }}
      <glxy-nav-item-accessory *ngTemplateOutlet="navIcon"></glxy-nav-item-accessory>
    </glxy-nav-item>
  </ng-container>
</ng-container>

<ng-container *ngIf="item.nestedItems?.length > 0">
  <glxy-nav-item-list
    [icon]="item.icon"
    [isSvg]="item.svgIcon"
    [id]="item.menuId"
    [startExpanded]="shouldExpandMenu"
    [attr.data-action]="'PartnerCenter:Nav:toggled-' + item.menuId"
  >
    {{ item.label | translate }}
    <glxy-nav-item-list-items>
      <app-nav-item
        *ngFor="let nesteditem of item.nestedItems"
        [activeMenuId]="activeMenuId"
        [item]="nesteditem"
      ></app-nav-item>
    </glxy-nav-item-list-items>
  </glxy-nav-item-list>
</ng-container>

<!-- Sets the contextual icon for a nav item -->
<ng-template #navIcon [ngSwitch]="navType">
  <mat-icon
    *ngSwitchCase="navLinkTypes.DISABLED"
    class="open-new-icon right-icon disabled"
    [glxyTooltip]="tooltip | translate"
    [tooltipPositions]="positions"
  >
    error_outline
  </mat-icon>
  <mat-icon *ngSwitchCase="navLinkTypes.LOCKED" class="other-icon right-icon">arrow_circle_up</mat-icon>
  <mat-icon *ngSwitchCase="navLinkTypes.POPOUT" class="open-new-icon right-icon">open_in_new</mat-icon>
  <i *ngSwitchCase="navLinkTypes.SUBNAV" [className]="item.rightIcon">chevron_right</i>
  <glxy-badge *ngSwitchCase="navLinkTypes.BETA" [size]="'small'" [color]="'blue-solid'">
    {{ 'COMMON.BETA' | translate }}
  </glxy-badge>
  <glxy-badge *ngSwitchCase="navLinkTypes.NEW" [size]="'small'" [color]="'green-solid'">
    {{ 'COMMON.NEW' | translate }}
  </glxy-badge>
</ng-template>
